import React from 'react';
import { Avatar, Box, HStack, Text, VStack } from '@chakra-ui/react';
import { normalizeCommunication } from '../utils/pabsCommunication';

// Keep the existing bubble vocabulary. A generated message is a bubble, not a
// paragraph reconstructed from findings, status labels or artifact summaries.
export function PabsMessageText({ communication, fallback = '', renderMessage, ...textProps }) {
  const messages = normalizeCommunication(communication, fallback).messages;
  return <VStack align="stretch" spacing={3}>{messages.map((text, index) =>
    renderMessage ? <Box key={index}>{renderMessage(text)}</Box>
      : <Text key={index} whiteSpace="pre-wrap" overflowWrap="anywhere" {...textProps}>{text}</Text>
  )}</VStack>;
}

export default function PabsResponse({ communication, fallback = '', children, ...stackProps }) {
  const messages = normalizeCommunication(communication, fallback).messages;
  if (!messages.length && !children) return null;
  return <VStack align="stretch" spacing={2.5} {...stackProps}>
    {(messages.length ? messages : ['']).map((text, index) => <HStack key={index} align="flex-start" spacing={2.5}>
      {index === 0 ? <Avatar name="Pabs" size="xs" bg="gray.800" color="white" flexShrink={0} mt={1}/>
        : <Box w="24px" flexShrink={0} aria-hidden="true"/>}
      <Box bg="gray.800" color="white" borderRadius="0px 16px 16px 16px" px={3.5} py={3} flex={1} minW={0} fontSize="sm" lineHeight="1.6">
        {text && <Text color="gray.100" whiteSpace="pre-wrap" overflowWrap="anywhere">{text}</Text>}
        {index === Math.max(messages.length - 1, 0) && children && <Box mt={text ? 3 : 0}>{children}</Box>}
      </Box>
    </HStack>)}
  </VStack>;
}
